export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", seq: "cat-shoes-27jun" },
  { name: "Hoodies/Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", seq: "cat-hoodies-27jun" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", seq: "cat-tshirts-27jun" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", seq: "cat-jackets-27jun" },
  { name: "Pants/Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", seq: "cat-pants-27jun" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", seq: "cat-headwear-27jun" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", seq: "cat-sets-27jun" },
  { name: "Underwear/Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", seq: "cat-underwear-27jun" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", seq: "cat-jersey-27jun" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", seq: "cat-accessories-27jun" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", seq: "cat-bags-27jun" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", seq: "cat-belts-27jun" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", seq: "cat-perfumes-27jun" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", seq: "cat-other-27jun" },
];

export const blogPosts = [
  {
    id: "itaobuyspreadsheet-2026-guide",
    slug: "itaobuyspreadsheet-2026-guide",
    title: "ItaobuySpreadsheet 2026 Guide: The Smart Way to Shop From China",
    summary: "Learn how curated spreadsheets are transforming the way international buyers discover and purchase products from Chinese marketplaces with verified agents and structured data.",
  },
  {
    id: "how-to-buy-from-china-safely",
    slug: "how-to-buy-from-china-safely",
    title: "How to Buy From China Safely Using Verified Agents",
    summary: "A complete breakdown of safe purchasing practices, agent verification methods, and risk management strategies when shopping from Taobao and 1688.",
  },
  {
    id: "agent-comparison-tips",
    slug: "agent-comparison-tips",
    title: "China Shopping Agent Comparison: What Matters Most in 2026",
    summary: "Compare shipping rates, service quality, and platform features across major China shopping agents to find your best match for spreadsheet-based buying.",
  },
  {
    id: "itaobuyspreadsheet-vs-superbuy",
    slug: "itaobuyspreadsheet-vs-superbuy",
    title: "ItaobuySpreadsheet vs Superbuy: Honest Comparison 2026",
    summary: "An in-depth side-by-side comparison of spreadsheet-based shopping versus traditional agent platforms like Superbuy, covering pricing, speed, and product discovery.",
  },
  {
    id: "cheapest-way-buy-from-china",
    slug: "cheapest-way-buy-from-china",
    title: "Cheapest Way to Buy From China Using Spreadsheets in 2026",
    summary: "Discover how spreadsheet shopping dramatically cuts international purchasing costs through bulk agent discounts, optimized shipping consolidation, and price transparency.",
  },
  {
    id: "is-itaobuyspreadsheet-safe",
    slug: "is-itaobuyspreadsheet-safe",
    title: "Is ItaobuySpreadsheet Safe? Full Security and Privacy Breakdown",
    summary: "A comprehensive analysis of safety protocols, agent verification systems, payment protection methods, and data privacy practices for spreadsheet-based China shopping.",
  },
  {
    id: "save-money-international-shipping",
    slug: "save-money-international-shipping",
    title: "How ItaobuySpreadsheet Saves You Money on International Shipping",
    summary: "Learn the specific strategies that spreadsheet shoppers use to reduce international shipping costs by up to 40% through consolidation, agent negotiation, and timing optimization.",
  },
  {
    id: "beginners-guide-taobao-spreadsheet",
    slug: "beginners-guide-taobao-spreadsheet",
    title: "Beginner's Complete Guide to Taobao Spreadsheet Shopping in 2026",
    summary: "A step-by-step walkthrough for first-time buyers covering everything from reading spreadsheets to placing your first order through a verified China shopping agent.",
  },
  {
    id: "itaobuyspreadsheet-pricing",
    slug: "itaobuyspreadsheet-pricing",
    title: "ItaobuySpreadsheet Pricing: What You Actually Pay in 2026",
    summary: "A transparent breakdown of all costs involved: product prices, agent service fees, international shipping rates, currency exchange fees, and how to minimize each expense category.",
  },
  {
    id: "top-products-itaobuyspreadsheet",
    slug: "top-products-itaobuyspreadsheet",
    title: "Top 10 Trending Products to Buy via ItaobuySpreadsheet This Season",
    summary: "Curated picks of the most popular and best-value items available through spreadsheet catalogs right now, from streetwear essentials to designer-inspired accessories.",
  },
  {
    id: "agent-verification-network",
    slug: "agent-verification-network",
    title: "ItaobuySpreadsheet Agent Network: How Verification and Quality Control Works",
    summary: "Behind the scenes of the agent verification process: how agents are vetted, monitored, and rated to ensure reliable service for international spreadsheet shoppers.",
  },
  {
    id: "spreadsheet-vs-agent-shopping",
    slug: "spreadsheet-vs-agent-shopping",
    title: "Spreadsheet Shopping vs Direct Agent Shopping: Which Method Wins in 2026?",
    summary: "An objective comparison of curated spreadsheet catalogs versus working directly with shopping agents, analyzing speed, cost, selection breadth, and overall buying experience.",
  },
];